import { getContrast } from '../../polished/lib';
import { colors } from '../lib/styles';

export default function getHighContrastTextColor(backgroundColor: string) {
    const lightTextContrast = getContrast(backgroundColor, colors.white);
    const darkTextContrast = getContrast(backgroundColor, colors.typography.root);

    return lightTextContrast > darkTextContrast ? colors.white : colors.typography.root;
}
